import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
    Link,
    useLocation,
} from 'react-router-dom';
import { connect } from 'react-redux';

import {
    Grid,
    Typography,
    Box,
    Avatar,
    Tooltip,
    IconButton,
    Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button as MuiButton,
    Checkbox,
    FormControlLabel,
} from '@mui/material';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';

import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import ThumbUpAltTwoToneIcon from '@mui/icons-material/ThumbUpAltTwoTone';
import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';

import { StackDateforDisplay } from '../../actions/app';
import { useNotificationCardFocus } from '../../utils/notificationDeepLink';
import {
    artistViewedHostOffer,
    deleteHostEvent,
    updateEventDate,
} from '../../actions/event';

import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import EditIcon from '@mui/icons-material/Edit';

// import EventDetails from '../events/EventDetails';

import Button from '../layout/SvgButton';
// import HostProfile from '../hosts/HostProfile';
// import { relativeTimeRounding } from 'moment';
// import ArtistDashboardBookingOffers from './ArtistDashboardBookingOffers';

import DeleteIcon from '@mui/icons-material/Delete';
import EditHostEvent from './EditHostEvent';

import EventHostDialog from './EventHostDialog';
import PlaceTwoToneIcon from '@mui/icons-material/PlaceTwoTone';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    ATTENDANCE_VISIBILITY_OPTIONS,
    attendanceVisibilityDetailsLine,
    normalizeAttendanceVisibility,
} from './AttendanceVisibilityPicker';

import HostReviewsEvent from '../hosts/HostReviewsEvent';
import VerifyAttendeesDialog from '../attendees/VerifyAttendeesDialog';

import CancelEventBtnDialog from './CancelEventBtnDialog';

// Date picker components used in HostEventForm
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';

const HostDashboardEventCard = ({
    thisEvent,
    artistViewedHostOffer,
    deleteHostEvent,
    eventEditDrawer,
    host,
    myHostEvents,
    updateEventDate,
    auth,
    onCancelStarted,
}) => {
    const isFutureEvent = (eventObj) => {
        if (!eventObj || !eventObj.bookingWhen) return false;
        return new Date(eventObj.bookingWhen) > new Date();
    };

    const showEditOverlay = (eventObj) => {
        return (
            isFutureEvent(eventObj) &&
            ((eventObj.createdBy === 'HOST' && eventObj.status === 'PENDING') ||
                eventObj.status === 'CONFIRMED')
        );
    };

    // Edit date dialog state
    const [editDateOpen, setEditDateOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null); // Dayjs | null
    const [hostContactedArtist, setHostContactedArtist] = useState(false);
    const location = useLocation();
    const { focused: notificationFocus, releaseFocus: releaseNotificationFocus } =
        useNotificationCardFocus(thisEvent && thisEvent._id);

    const handleEditDateClick = (eventObj) => {
        const initial =
            eventObj && eventObj.bookingWhen
                ? dayjs(new Date(eventObj.bookingWhen))
                : null;
        setSelectedDate(initial);
        setHostContactedArtist(false);
        setEditDateOpen(true);
    };

    const handleCloseEditDate = () => {
        setEditDateOpen(false);
        setSelectedDate(null);
        setHostContactedArtist(false);
    };

    const normalizeId = (id) => {
        if (!id) return null;
        return String(typeof id === 'string' ? id : id._id || id);
    };

    const getCurrentHostOffer = (thisEvent) => {
        const currentHostId = normalizeId(host.me?._id);

        if (!currentHostId || !thisEvent.offersFromHosts) {
            return null;
        }

        return (
            thisEvent.offersFromHosts.find(
                (offer) => normalizeId(offer.host) === currentHostId
            ) || null
        );
    };

    const confirmedMy = (thisEvent) =>
        thisEvent.createdBy !== 'HOST' &&
        thisEvent.confirmedHost &&
        normalizeId(thisEvent.confirmedHost) === normalizeId(host.me?._id)
            ? true
            : false;

    const confirmedHostProposed = (thisEvent) => {
        const currentHostId = normalizeId(host.me?._id);

        return thisEvent.createdBy === 'HOST' &&
            thisEvent.status === 'CONFIRMED' &&
            currentHostId &&
            (normalizeId(thisEvent.confirmedHost) === currentHostId ||
                getCurrentHostOffer(thisEvent))
            ? true
            : false;
    };

    const isAcceptedHostForEvent = (eventObj) =>
        confirmedMy(eventObj) || confirmedHostProposed(eventObj);

    const showVerifyAttendees =
        thisEvent.status === 'CONFIRMED' &&
        normalizeId(thisEvent.confirmedHost) === normalizeId(host.me?._id);
    const isThisHostConfirmedHost =
        normalizeId(thisEvent.confirmedHost) === normalizeId(host.me?._id);
    const attendanceVisibility = normalizeAttendanceVisibility(
        thisEvent.attendanceVisibility
    );
    const attendanceVisibilityOption = ATTENDANCE_VISIBILITY_OPTIONS.find(
        (option) => option.value === attendanceVisibility
    );
    const attendanceVisibilityLabel =
        (attendanceVisibilityOption &&
            attendanceVisibilityOption.shortLabel) ||
        'Invite-only';
    //console.log('HostDashboardEventCard thisEvent:', thisEvent);

    //Booking Details Dialog Functions
    // const [eventDetailsDialogOpen, setEventDetailsDialogOpen] = useState(false);

    // const [wantsToBook, setWantsToBook] = useState(false);

    // const eventDetailsDialogHandleClose = () => {
    //     setDialogDetailsState({});
    //     setEventDetailsDialogOpen(false);
    //     setWantsToBook(false);
    // };

    // const [eventDialogDetails, setDialogDetailsState] = useState({});

    // useEffect(() => {
    //     //console.log('eventDialogDetails', eventDialogDetails);
    //     setEventDetailsDialogOpen(true);
    // }, [eventDialogDetails]);

    // const handleEventBtnClick = (theOffer) => {
    //     setDialogDetailsState(theOffer);
    // };
    //End of Dialog Functions

    //for animated border
    const dashboardEventCardRef = useRef(null);
    const [eventCardHeight, setHeight] = useState(0);
    const [eventCardWidth, setWidth] = useState(0);
    useEffect(() => {
        setHeight(dashboardEventCardRef.current.offsetHeight);
        setWidth(dashboardEventCardRef.current.offsetWidth);

        // console.log('HostDashboardEventCard thisEvent', thisEvent);
    }, []);

    useEffect(() => {
        if (thisEvent._id === eventEditDrawer) {
            if (dashboardEventCardRef.current) {
                dashboardEventCardRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
            //console.log('eventEditDrawer', eventEditDrawer);
        }
    }, [eventEditDrawer]);

    useEffect(() => {
        const eventID = new URLSearchParams(location.search).get('eventID');
        if (!eventID || String(thisEvent._id) !== String(eventID)) return;
        const timer = setTimeout(() => {
            if (dashboardEventCardRef.current) {
                dashboardEventCardRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                });
            }
        }, 400);
        return () => clearTimeout(timer);
    }, [thisEvent._id, location.search, location.key]);

    // Helper function to check if current host has made an offer for this event
    const hasHostOffered = (thisEvent) => {
        return Boolean(getCurrentHostOffer(thisEvent));
    };

    // Check if we're waiting for artist reply (event is pending and host has offered)
    const waitingForArtistReply = () => {
        // Must be pending and host must have made an offer
        if (thisEvent.status !== 'PENDING' || !hasHostOffered(thisEvent)) {
            return false;
        }

        // If there's a confirmed artist, we're waiting for their response
        if (thisEvent.artist) {
            return true;
        }

        // If there are preferred artists but no confirmed artist, we're waiting for them
        if (
            thisEvent.preferredArtists &&
            thisEvent.preferredArtists.length > 0
        ) {
            return true;
        }

        return false;
    };

    const getWaitingMessage = () => {
        if (thisEvent.artist && thisEvent.artist.stageName) {
            return `${thisEvent.artist.stageName} is still considering your offer.`;
        } else if (
            thisEvent.preferredArtists &&
            thisEvent.preferredArtists.length > 0
        ) {
            const totalArtists = thisEvent.preferredArtists.length;
            const declinedCount = thisEvent.declinedArtists
                ? thisEvent.declinedArtists.length
                : 0;
            const stillConsidering = totalArtists - declinedCount;

            if (stillConsidering <= 0) {
                return 'All of the artists declined your offer.';
            } else if (stillConsidering < 4) {
                // Get the list of declined artist IDs
                const declinedArtistIds = thisEvent.declinedArtists
                    ? thisEvent.declinedArtists.map((declined) =>
                          declined.artist.toString()
                      )
                    : [];

                // Filter out declined artists and get stage names
                const stillConsideringArtists = thisEvent.preferredArtists
                    .filter(
                        (artist) =>
                            !declinedArtistIds.includes(artist._id.toString())
                    )
                    .map((artist) => artist.stageName || 'Unknown Artist');

                if (totalArtists === 1) {
                    return `Waiting for ${
                        thisEvent.preferredArtists[0].stageName || 'the artist'
                    } to respond.`;
                }
                // Format the names properly
                if (stillConsideringArtists.length === 2) {
                    return `${stillConsideringArtists[0]} and ${stillConsideringArtists[1]} are still considering your offer.`;
                } else if (stillConsideringArtists.length === 1) {
                    return `Waiting for ${
                        stillConsideringArtists[0] || 'the artist'
                    } to respond.`;
                } else {
                    const lastArtist = stillConsideringArtists.pop();
                    return `${stillConsideringArtists.join(
                        ', '
                    )}, and ${lastArtist} are still considering your offer.`;
                }
            } else {
                return `${stillConsidering} artists are still considering your offer.`;
            }
        }
        return 'Waiting for artist response.';
    };

    const currentHostOffer = getCurrentHostOffer(thisEvent);

    return (
        <>
            <Grid
                container
                item
                className={
                    (thisEvent._id === eventEditDrawer
                        ? 'bookingWhen mostRecent'
                        : 'bookingWhen') +
                    (notificationFocus ? ' notificationFocus' : '')
                }
                direction="row"
                // sm={5.5}
                // xs={12}
                size={{ xs: 12, sm: 12 }}
                id={thisEvent._id ? String(thisEvent._id) : undefined}
                ref={dashboardEventCardRef}
                sx={{
                    backgroundColor: 'rgba(0,0,0,0.35)',
                    '&:hover': {},
                    padding: '16px',
                    margin: '4px',
                    color: 'var(--light-color)',
                    justifyContent: 'space-between',
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    // border:
                    //     thisEvent._id === eventEditDrawer
                    //         ? '1px solid var(--dark-color)'
                    //         : '1px solid transparent',
                    // transition: 'all .8s cubic-bezier(0.23, 1, 0.32, 1) 0ms',
                    // transitionDelay: '.8s',
                    // boxShadow:
                    //     thisEvent._id === eventEditDrawer
                    //         ? '0 0 5px 0px var(--dark-color)'
                    //         : ' 0 0 0 0 transparent',
                    position: 'relative',
                    backgroundImage:
                        thisEvent.status === 'DRAFT'
                            ? 'repeating-linear-gradient(45deg,     rgba(255,255,255,0.03) 5px,    rgba(255,255,255,.03) 15px,    transparent 15px,    transparent 30px)'
                            : thisEvent.status === 'CANCELED'
                              ? 'repeating-linear-gradient(45deg, rgb(255 0 0 / 10%) 5px, rgb(255 0 0 / 10%) 15px, transparent 15px, transparent 30px)'
                              : 'none',
                    border:
                        thisEvent.status === 'DRAFT'
                            ? '4px dashed var(--primary-color)!important'
                            : // : thisEvent.status === 'CANCELED'
                              // ? '4px dashed var(--red)!important'
                              '1px solid transparent',
                    maskImage:
                        thisEvent.status === 'CANCELED'
                            ? 'radial-gradient(black 50%, transparent)'
                            : 'none',
                    opacity: thisEvent.status === 'DRAFT' ? '0.7' : '1',
                    flexDirection:
                        thisEvent.status === 'CONFIRMED' &&
                        new Date(thisEvent.bookingWhen) < new Date()
                            ? 'column'
                            : 'row',
                }}
            >
                <svg
                    width={eventCardWidth}
                    height={eventCardHeight}
                    className={
                        thisEvent.status === 'DRAFT'
                            ? 'eventCardSvgBorder eventDraft'
                            : 'eventCardSvgBorder'
                    }
                    style={{
                        pointerEvents: 'none',
                    }}
                >
                    <polygon
                        points={
                            '0,' +
                            eventCardHeight +
                            ' 0,0 ' +
                            eventCardWidth +
                            ',0 ' +
                            eventCardWidth +
                            ',' +
                            eventCardHeight +
                            ''
                        }
                        className={
                            thisEvent._id === eventEditDrawer
                                ? 'borderEffect'
                                : ''
                        }
                        style={{
                            strokeDasharray: `${eventCardHeight * 2} ${
                                eventCardHeight * 2 + eventCardWidth * 2
                            }`,
                            strokeDashoffset:
                                thisEvent._id === eventEditDrawer
                                    ? `${eventCardHeight * 2}`
                                    : `${
                                          eventCardHeight * 2 +
                                          eventCardWidth * 3
                                      }`,
                        }}
                    />
                </svg>
                <Grid
                    container
                    item
                    direction="row"
                    alignItems="center"
                    className="dateLocationForBookingWrapper"
                    sx={{
                        // flexWrap: 'nowrap'
                        margin: { xs: '10px auto', sm: '0px auto' },
                        justifyContent: {
                            xs: 'center',
                            sm: 'space-evenly',
                        },
                        width: '100%',
                    }}
                    // xs={12}
                    size={{ xs: 12 }}
                >
                    {thisEvent.artist &&
                        thisEvent.artist.squareImg &&
                        thisEvent.artist.slug && (
                            <Grid
                                className="feoyAvatarGridItem"
                                item
                                sx={{
                                    // width: '100%',
                                    flexBasis: { xs: '80px', sm: '130px' },
                                    flexShrink: '3',
                                    flexGrow: '2',
                                }}
                            >
                                <Link
                                    to={'/artists/' + thisEvent.artist.slug}
                                    className={
                                        `feoyartist` +
                                        thisEvent.artist._id +
                                        thisEvent._id
                                    }
                                >
                                    <Tooltip
                                        title={
                                            thisEvent.artist &&
                                            thisEvent.artist.stageName +
                                                ' accepted your offer.'
                                        }
                                        arrow={true}
                                        placement="bottom"
                                        disableHoverListener={
                                            !confirmedMy(thisEvent)
                                        }
                                        disableFocusListener={
                                            !confirmedMy(thisEvent)
                                        }
                                        disableTouchListener={
                                            !confirmedMy(thisEvent)
                                        }
                                    >
                                        <Box
                                            className="squareImgInACircle"
                                            sx={{
                                                height: 'auto',
                                                width: 'auto',
                                                // maxHeight: { xs: '100px', sm: '130px' },
                                                maxHeight: '130px',
                                                // maxWidth: { xs: '100px', sm: '130px' },
                                                maxWidth: '130px',
                                                borderRadius: '50%',
                                                overflow: 'hidden',
                                                backgroundImage: `url("${
                                                    thisEvent.artist &&
                                                    thisEvent.artist.squareImg
                                                }")`,
                                                backgroundPosition: '50% 25%',
                                                backgroundSize: 'cover',
                                                padding: '4px',
                                                backgroundClip: 'content-box',
                                                border: confirmedMy(thisEvent)
                                                    ? '1px solid var(--link-color)'
                                                    : '1px solid var(--primary-color)',
                                                margin: {
                                                    xs: 'auto',
                                                    sm: '0 8px 0 0',
                                                },
                                                aspectRatio: '1 / 1',
                                            }}
                                        ></Box>
                                    </Tooltip>
                                </Link>
                            </Grid>
                        )}

                    {thisEvent.preferredArtists &&
                        thisEvent.preferredArtists.length > 0 && (
                            <Grid
                                item
                                sx={{
                                    width: '130px',
                                    height: '130px',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    flexDirection: 'row',
                                    margin: '0 8px 0 0',
                                    justifyContent: 'space-around',
                                    // alignItems: 'space-between',
                                    alignContent: 'space-evenly',
                                }}
                                className="preferredArtistsWrapper"
                            >
                                {thisEvent.preferredArtists.map(
                                    (prefArtist) => {
                                        let avatarSize =
                                            130 /
                                                thisEvent.preferredArtists
                                                    .length -
                                            4 *
                                                (thisEvent.preferredArtists
                                                    .length -
                                                    1);

                                        let confirmed = false;

                                        if (
                                            thisEvent.confirmedArtist &&
                                            (thisEvent.confirmedArtist ===
                                                prefArtist._id ||
                                                thisEvent.confirmedArtist
                                                    ._id === prefArtist._id)
                                        ) {
                                            confirmed = true;
                                        }
                                        let declined = false;

                                        if (
                                            thisEvent.declinedArtists &&
                                            thisEvent.declinedArtists.length >
                                                -1
                                        ) {
                                            declined =
                                                thisEvent.declinedArtists.filter(
                                                    (declinedArtist) => {
                                                        // console.log(
                                                        //     'declinedArtist.artist | prefArtist._id',
                                                        //     declinedArtist.artist +
                                                        //         ' | ' +
                                                        //         prefArtist._id
                                                        // );
                                                        return (
                                                            declinedArtist.artist ===
                                                            prefArtist._id
                                                        );
                                                    }
                                                ).length > 0;
                                            // console.log('declined', declined);
                                        }

                                        if (
                                            thisEvent.preferredArtists.length >
                                            2
                                        ) {
                                            // Find the square root of the input number
                                            const squareRoot = Math.sqrt(
                                                thisEvent.preferredArtists
                                                    .length
                                            );

                                            // Round up the square root to the nearest integer
                                            const roundedSquareRoot =
                                                Math.ceil(squareRoot);

                                            // Calculate the square of the rounded square root
                                            const roundedSquare =
                                                roundedSquareRoot *
                                                roundedSquareRoot;

                                            avatarSize =
                                                130 / roundedSquareRoot -
                                                4 * (roundedSquareRoot - 1);
                                        }

                                        return (
                                            <Fragment
                                                key={
                                                    `preffedArtistFragment` +
                                                    prefArtist._id +
                                                    thisEvent._id
                                                }
                                            >
                                                <Tooltip
                                                    title={
                                                        !confirmed &&
                                                        !declined &&
                                                        thisEvent.status !==
                                                            'DRAFT'
                                                            ? 'Haven’t heard from ' +
                                                              prefArtist.stageName +
                                                              '.'
                                                            : confirmed === true
                                                              ? prefArtist.stageName +
                                                                ' accepted your offer.'
                                                              : declined ===
                                                                  true
                                                                ? prefArtist.stageName +
                                                                  ' declined your offer.'
                                                                : prefArtist.stageName
                                                    }
                                                    placement="bottom"
                                                    arrow
                                                >
                                                    {/* <Grid
                                                    item
                                                    sx={{
                                                        // width: '100%',
                                                        flexBasis: {
                                                            xs: '80px',
                                                            sm: '130px',
                                                        },
                                                        flexShrink: '3',
                                                        flexGrow: '2',
                                                    }}
                                                > */}
                                                    <Box
                                                        className="squareImgInACircle"
                                                        sx={{
                                                            display: 'flex',
                                                            width:
                                                                avatarSize +
                                                                'px',
                                                            height:
                                                                avatarSize +
                                                                'px',
                                                            maxHeight:
                                                                avatarSize +
                                                                'px',
                                                            maxWidth:
                                                                avatarSize +
                                                                'px',
                                                            borderRadius: '50%',
                                                            overflow: 'hidden',
                                                            backgroundImage: `url("${prefArtist.squareImg}")`,
                                                            backgroundBlendMode:
                                                                confirmed
                                                                    ? 'normal'
                                                                    : declined
                                                                      ? 'soft-light'
                                                                      : 'soft-light',
                                                            filter: declined
                                                                ? 'grayscale(100%)'
                                                                : '',
                                                            backgroundColor:
                                                                'rgba(0,0,0,0.5)',
                                                            backgroundPosition:
                                                                '50% 25%',
                                                            backgroundSize:
                                                                'cover',
                                                            padding: '4px',
                                                            backgroundClip:
                                                                'content-box',
                                                            border: confirmed
                                                                ? '1px solid var(--link-color)'
                                                                : declined
                                                                  ? '1px solid #777'
                                                                  : '1px dashed var(--primary-color)',
                                                            // margin: '0 8px 0 0',
                                                            justifyContent:
                                                                'center',
                                                            alignItems:
                                                                'center',
                                                            aspectRatio:
                                                                '1 / 1',
                                                        }}
                                                    >
                                                        {!confirmed &&
                                                        !declined ? (
                                                            <Typography
                                                                sx={{
                                                                    fontFamily:
                                                                        'Tahoma',
                                                                    margin: 'auto',
                                                                    fontSize:
                                                                        avatarSize *
                                                                            0.8 +
                                                                        'px',
                                                                    opacity:
                                                                        '.2',
                                                                    lineHeight:
                                                                        '1',
                                                                    textShadow:
                                                                        '0 0 5px rgba(0,0,0,1), 0 0 5px rgba(0,0,0,1), 0 0 5px rgba(0,0,0,1);',
                                                                    cursor: 'default',
                                                                    width: '100%',
                                                                    textAlign:
                                                                        'center',
                                                                    borderRadius:
                                                                        '100%',
                                                                }}
                                                            >
                                                                ?
                                                            </Typography>
                                                        ) : (
                                                            //this is here just for the sake of the Tooltip working
                                                            <Typography
                                                                sx={{
                                                                    fontFamily:
                                                                        'Tahoma',
                                                                    margin: 'auto',
                                                                    fontSize:
                                                                        avatarSize *
                                                                            0.8 +
                                                                        'px',
                                                                    opacity:
                                                                        '.2',
                                                                    lineHeight:
                                                                        '1',
                                                                    textShadow:
                                                                        '0 0 5px rgba(0,0,0,1), 0 0 5px rgba(0,0,0,1), 0 0 5px rgba(0,0,0,1);',
                                                                    cursor: 'default',
                                                                    width: '100%',
                                                                    textAlign:
                                                                        'center',
                                                                    borderRadius:
                                                                        '100%',
                                                                }}
                                                            ></Typography>
                                                        )}
                                                    </Box>
                                                    {/* </Grid> */}
                                                </Tooltip>
                                            </Fragment>
                                        );
                                    }
                                )}
                            </Grid>
                        )}

                    <Grid
                        container
                        item
                        direction="column"
                        alignItems="flex-start"
                        className="dateLocationForBooking"
                        sx={{
                            flexBasis: {
                                sm: thisEvent.confirmedHost
                                    ? `calc(100% - 150px - 25px)`
                                    : `calc(100% - 150px)`,
                                xs: 'none',
                            },
                            // flexBasis: thisEvent.confirmedHost
                            //     ? `calc(100% - 150px - 25px)`
                            //     : `calc(100% - 150px)`,

                            flexGrow: '1',
                        }}
                        // xs={
                        //     thisEvent.artist && thisEvent.artist.squareImg
                        //         ? 8
                        //         : 12
                        // }
                        // sm={
                        //     thisEvent.artist && thisEvent.artist.squareImg
                        //         ? 8
                        //         : 8
                        // }
                    >
                        <Grid item container>
                            <Link
                                to={
                                    '/artists/' +
                                    (thisEvent.artist && thisEvent.artist.slug)
                                }
                            >
                                <Typography component="h2">
                                    {thisEvent.artist &&
                                        thisEvent.artist.stageName}
                                </Typography>
                            </Link>
                        </Grid>
                        <Grid
                            container
                            item
                            className="feoyDateLocation"
                            sx={{
                                flexWrap: 'nowrap',
                                // width: '100%',
                            }}
                            size={{ xs: 12 }}
                        >
                            <Grid item className="dateGrid">
                                <Box
                                    sx={{
                                        position: 'relative',
                                        display: 'inline-block',
                                        '&:hover .dateEditBtn': {
                                            opacity: 1,
                                            pointerEvents: 'auto',
                                        },
                                    }}
                                    className="dateBox"
                                >
                                    <StackDateforDisplay
                                        date={thisEvent.bookingWhen}
                                    />
                                    {showEditOverlay(thisEvent) && (
                                        <Tooltip
                                            title="Change the date"
                                            placement="top"
                                            arrow
                                        >
                                            <IconButton
                                                size="large"
                                                onClick={() =>
                                                    handleEditDateClick(
                                                        thisEvent
                                                    )
                                                }
                                                className="dateEditBtn"
                                                sx={{
                                                    position: 'absolute',
                                                    inset: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    zIndex: 2,
                                                    borderRadius: '0px',
                                                    p: 0,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    backgroundColor:
                                                        'rgba(0,0,0,0.25)',
                                                    '&:hover': {
                                                        backgroundColor:
                                                            'rgba(0,0,0,0.45)',
                                                    },
                                                    opacity: 0,
                                                    pointerEvents: 'none',
                                                    transition:
                                                        'opacity 150ms ease-in-out',
                                                }}
                                            >
                                                <EditIcon fontSize="large" />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </Box>
                            </Grid>
                            <Grid
                                item
                                className="locationGridItem"
                                // xs={
                                //     thisEvent.artist &&
                                //     thisEvent.artist.squareImg
                                //         ? 8
                                //         : 9
                                // }
                                size={{
                                    xs:
                                        thisEvent.artist &&
                                        thisEvent.artist.squareImg
                                            ? // ? 8
                                              // : 9,
                                              10
                                            : 11,
                                }}
                                sx={{
                                    marginLeft: '8px',
                                }}
                            >
                                <Grid
                                    item
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                        flexWrap: 'wrap',
                                        minWidth: 0,
                                    }}
                                    // xs={12}
                                    size={{ xs: 12 }}
                                    className="locationCityStateGridItem"
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            fontSize: {
                                                xs: '1.2em',
                                                sm: '1.5em',
                                            },
                                            lineHeight: '1.5',
                                        }}
                                    >
                                        {thisEvent.bookingWhere.city +
                                            ', ' +
                                            thisEvent.bookingWhere.state}
                                    </Box>
                                    {isThisHostConfirmedHost &&
                                        thisEvent.status !== 'CANCELED' && (
                                            <Tooltip
                                                title={attendanceVisibilityDetailsLine(
                                                    attendanceVisibility
                                                )}
                                                placement="bottom"
                                                arrow
                                            >
                                                <Chip
                                                    variant="outlined"
                                                    color="warning"
                                                    size="small"
                                                    icon={
                                                        <VisibilityIcon fontSize="small" />
                                                    }
                                                    label={
                                                        attendanceVisibilityLabel
                                                    }
                                                    sx={{
                                                        fontFamily:
                                                            'var(--secondary-font)',
                                                        height: '24px',
                                                        flexShrink: 0,
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                </Grid>
                                {thisEvent.createdBy === 'HOST' &&
                                    thisEvent.status === 'DRAFT' && (
                                        <Grid item container>
                                            <EditHostEvent
                                                theEvent={thisEvent}
                                            ></EditHostEvent>
                                        </Grid>
                                    )}
                                {thisEvent.createdBy === 'HOST' &&
                                    thisEvent.status != 'DRAFT' && (
                                        <Grid item container sx={{ gap: '8px' }}>
                                            <EventHostDialog
                                                theHost={host.me}
                                                theEvent={thisEvent}
                                                theOffer={
                                                    thisEvent.offersFromHosts[0]
                                                }
                                            >
                                                <Button btnwidth="200">
                                                    CONCERT DETAILS
                                                </Button>
                                            </EventHostDialog>
                                            {thisEvent.status === 'CONFIRMED' &&
                                                isAcceptedHostForEvent(
                                                    thisEvent
                                                ) && (
                                                    <Link
                                                        to={`/events/${thisEvent._id}`}
                                                        style={{
                                                            textDecoration:
                                                                'none',
                                                        }}
                                                    >
                                                        <Button btnwidth="160">
                                                            Event Page
                                                        </Button>
                                                    </Link>
                                                )}
                                            {showVerifyAttendees && (
                                                <VerifyAttendeesDialog
                                                    theEvent={thisEvent}
                                                />
                                            )}
                                        </Grid>
                                    )}
                                {thisEvent.createdBy === 'ARTIST' && (
                                    <Grid item container sx={{ gap: '8px' }}>
                                        <EventHostDialog
                                            theHost={host.me}
                                            theEvent={thisEvent}
                                            theOffer={currentHostOffer}
                                        >
                                            <Button btnwidth="200">
                                                CONCERT DETAILS
                                            </Button>
                                        </EventHostDialog>
                                        {thisEvent.status === 'CONFIRMED' &&
                                            isAcceptedHostForEvent(
                                                thisEvent
                                            ) && (
                                                <Link
                                                    to={`/events/${thisEvent._id}`}
                                                    style={{
                                                        textDecoration: 'none',
                                                    }}
                                                >
                                                        <Button btnwidth="160">
                                                            Event Page
                                                        </Button>
                                                    </Link>
                                                )}
                                            {showVerifyAttendees && (
                                                <VerifyAttendeesDialog
                                                    theEvent={thisEvent}
                                                />
                                            )}
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    {confirmedMy(thisEvent) ||
                    confirmedHostProposed(thisEvent) ? (
                        <Grid
                            item
                            alignContent="center"
                            container
                            // xs={0.5}
                            size={{ xs: 0.5 }}
                            className="confirmedThumbUp"
                            sx={{ zIndex: '10' }}
                        >
                            <Tooltip
                                title={
                                    thisEvent.artist &&
                                    thisEvent.artist.stageName
                                        ? thisEvent.artist.stageName +
                                          ' accepted your offer.'
                                        : 'Confirmed'
                                }
                                placement="bottom"
                                arrow
                            >
                                <ThumbUpAltTwoToneIcon
                                    sx={{
                                        color: 'var(--link-color)',
                                    }}
                                ></ThumbUpAltTwoToneIcon>
                            </Tooltip>
                        </Grid>
                    ) : (
                        thisEvent.createdBy !== 'HOST' && //if this event is not created by a host
                        thisEvent.confirmedHost && //and if the event has a confirmedHost
                        !confirmedMy(thisEvent) && ( //and it's not me
                            <Grid
                                item
                                alignContent="center"
                                container
                                sx={{
                                    flexBasis: '25px',
                                    flexGrow: '0',
                                    marginLeft: '8px',
                                }}
                                style={{ zIndex: '5' }}
                            >
                                <Tooltip
                                    title={
                                        (thisEvent.artist &&
                                            thisEvent.artist.stageName) +
                                        ' accepted a different host’s offer.'
                                    }
                                    placement="bottom"
                                    arrow
                                >
                                    <ThumbDownAltTwoToneIcon
                                        sx={{
                                            color: 'var(--primary-color)',
                                        }}
                                    ></ThumbDownAltTwoToneIcon>
                                </Tooltip>
                            </Grid>
                        )
                    )}
                    {waitingForArtistReply() && (
                        <Grid
                            item
                            sx={{
                                position: 'absolute',
                                top: '5px',
                                right: '5px',
                                color: 'var(--primary-color)',
                                padding: '2px 8px',
                                fontSize: '11px',
                                zIndex: 10,
                            }}
                        >
                            {getWaitingMessage()}
                        </Grid>
                    )}
                    {/* <Grid item xs={9} sx={{ margin: '8px 0 0' }}>
                    <Grid
                        item
                        sx={{
                            fontSize: '1.5em',
                            marginLeft: '8px',
                            lineHeight: '1.5',
                        }}
                    >
                        {thisEvent.bookingWhere.city +
                            ', ' +
                            thisEvent.bookingWhere.state}
                    </Grid> 
                    {
                        
                    }
                </Grid>*/}
                </Grid>
                {thisEvent.status === 'DRAFT' && !thisEvent.artist && (
                    <Grid
                        container
                        item
                        flexDirection={{ xs: 'row-reverse', sm: 'column' }}
                        flexWrap={'nowrap'}
                        alignItems="center"
                        justifyContent="space-between"
                        // xs={12}
                        // sm={1}
                        size={{ xs: 12, sm: 1 }}
                        className="draftEventStuff"
                    >
                        <Grid
                            item
                            className="deleteBtn"
                            // xs={1}
                            style={{
                                // alignSelf: 'flex-start',
                                justifyContent: 'center',
                            }}
                        >
                            <IconButton
                                onClick={(e) => deleteHostEvent(thisEvent._id)}
                                size="large"
                            >
                                <DeleteIcon></DeleteIcon>
                            </IconButton>
                        </Grid>
                        <Grid
                            item
                            className="warningIcon"
                            // xs={1}
                            style={{
                                color: 'var(--primary-color)',
                                // alignSelf: 'flex-end',
                                justifyContent: 'center',
                                zIndex: '5',
                            }}
                        >
                            <Tooltip
                                arrow={true}
                                placement="bottom"
                                title={
                                    <>
                                        <div
                                            style={{
                                                textAlign: 'center',
                                            }}
                                        >{`This offer is still a DRAFT and has not been sent to ${
                                            thisEvent.preferredArtists.length >
                                            1
                                                ? 'the artists'
                                                : thisEvent
                                                        .preferredArtists[0] &&
                                                    thisEvent
                                                        .preferredArtists[0]
                                                        .stageName
                                                  ? thisEvent
                                                        .preferredArtists[0]
                                                        .stageName
                                                  : 'the artist'
                                        }, yet.`}</div>
                                    </>
                                }
                            >
                                <WarningAmberIcon></WarningAmberIcon>
                            </Tooltip>
                            <Box
                                className="draftEventWarning"
                                sx={{
                                    display: { xs: 'inline', sm: 'none' },
                                    textAlign: 'center',
                                    marginLeft: '5px',
                                    fontSize: '11px',
                                }}
                            >{`This offer is still a DRAFT and has not been sent to ${
                                thisEvent.preferredArtists.length > 1
                                    ? 'the artists'
                                    : thisEvent.preferredArtists[0] &&
                                        thisEvent.preferredArtists[0].stageName
                                      ? thisEvent.preferredArtists[0].stageName
                                      : 'the artist'
                            }, yet.`}</Box>
                        </Grid>
                    </Grid>
                )}
                {thisEvent.status === 'CONFIRMED' &&
                    new Date(thisEvent.bookingWhen) < new Date() && ( //bookingWhen is older than today
                        <HostReviewsEvent
                            theEvent={thisEvent}
                            onNotificationDialogClose={releaseNotificationFocus}
                        ></HostReviewsEvent>
                    )}

                <CancelEventBtnDialog
                    theEvent={thisEvent}
                    canceledBy={'HOST'}
                    onCancelStarted={onCancelStarted}
                ></CancelEventBtnDialog>

                {thisEvent.status === 'CANCELED' && thisEvent.canceledDate && (
                    <Typography
                        component={'p'}
                        sx={{
                            color: 'var(--red)',
                            fontSize: '10px',
                            position: 'absolute',
                            bottom: '5px',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            textAlign: 'center',
                        }}
                    >
                        Canceled on:{' '}
                        {new Date(thisEvent.canceledDate).toLocaleDateString(
                            undefined,
                            {
                                // weekday: 'long',
                                year: 'numeric',
                                month: 'numeric',
                                day: 'numeric',
                                timeZone: 'UTC', //fixes timezone issues where users see the date a day off sometimes
                            }
                        )}
                    </Typography>
                )}
            </Grid>

            {/* Edit Date Dialog */}
            <Dialog
                open={editDateOpen}
                onClose={handleCloseEditDate}
                fullWidth
                maxWidth="xs"
                className="porchlightBG"
            >
                <DialogTitle>Change the date</DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateCalendar
                            disablePast
                            value={selectedDate}
                            onChange={(newVal) => {
                                // newVal is a Dayjs instance or null
                                setSelectedDate(newVal);
                            }}
                            shouldDisableDate={(date) => {
                                // Disable dates already used by this host (except this event's own date)
                                if (!Array.isArray(myHostEvents)) return false;
                                const iso =
                                    date && typeof date.toDate === 'function'
                                        ? date.toDate().toISOString()
                                        : new Date(date).toISOString();
                                const thisEventIso =
                                    thisEvent && thisEvent.bookingWhen
                                        ? new Date(
                                              thisEvent.bookingWhen
                                          ).toISOString()
                                        : '';
                                return myHostEvents
                                    .filter((e) => e.status !== 'CANCELED')
                                    .some(
                                        (e) =>
                                            e.bookingWhen === iso &&
                                            iso !== thisEventIso
                                    );
                            }}
                        />
                    </LocalizationProvider>
                    {thisEvent.status === 'CONFIRMED' &&
                        thisEvent.confirmedArtist && (
                            <Box
                                sx={{
                                    mt: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <Avatar
                                    src={thisEvent?.confirmedArtist?.squareImg}
                                    alt={thisEvent?.confirmedArtist?.stageName}
                                    sx={{ width: 40, height: 40, mr: 1 }}
                                />
                                <Typography
                                    component="p"
                                    sx={{ color: 'var(--primary-color)' }}
                                >
                                    Please confirm you’ve reached out to{' '}
                                    {thisEvent?.confirmedArtist?.stageName} to
                                    discuss this change. An email will be sent
                                    to anyone who needs to know about the
                                    change.
                                </Typography>
                            </Box>
                        )}
                    {thisEvent.status === 'CONFIRMED' && (
                        <FormControlLabel
                            sx={{ mt: 1 }}
                            control={
                                <Checkbox
                                    checked={hostContactedArtist}
                                    onChange={(e) =>
                                        setHostContactedArtist(e.target.checked)
                                    }
                                />
                            }
                            label={`Yes, I’ve reached out to ${thisEvent?.confirmedArtist?.stageName || 'the artist'} about this change.`}
                        />
                    )}
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button onClick={handleCloseEditDate}>Cancel</Button>
                    <Button
                        onClick={() => {
                            if (selectedDate && selectedDate.isValid?.()) {
                                const iso = selectedDate.toDate().toISOString();
                                const notify = thisEvent.status === 'CONFIRMED';
                                updateEventDate(thisEvent._id, iso, {
                                    notify,
                                    hostContacted: hostContactedArtist,
                                });
                            }
                            handleCloseEditDate();
                        }}
                        disabled={
                            !selectedDate ||
                            !selectedDate.isValid?.() ||
                            (thisEvent.status === 'CONFIRMED' &&
                                !hostContactedArtist)
                        }
                        variant="contained"
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

HostDashboardEventCard.propTypes = {
    thisEvent: PropTypes.object.isRequired,
    artistViewedHostOffer: PropTypes.func.isRequired,
    deleteHostEvent: PropTypes.func.isRequired,
    eventEditDrawer: PropTypes.string,
    host: PropTypes.object.isRequired,
    myHostEvents: PropTypes.array,
    auth: PropTypes.object,
    onCancelStarted: PropTypes.func,
};

const mapStateToProps = (state) => ({
    eventEditDrawer: state.app.eventEditDrawer,
    host: state.host,
    myHostEvents: state.event && state.event.myHostEvents,
    auth: state.auth,
});

//export default HostDashboardEventCard;
export default connect(mapStateToProps, {
    artistViewedHostOffer,
    deleteHostEvent,
    updateEventDate,
    // })(withRouter(HostDashboardEventCard)); //withRouter allows us to pass history objects
})(HostDashboardEventCard);
